var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortugal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0001C0 22.8795 4.342 28.7442 10.4347 31.0049L11.8261 16.0001L10.4347 0.995331C4.342 3.25608 0 9.12071 0 16.0001Z",
    fill: "#6DA544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 16C31.9999 7.1635 24.8364 0 15.9999 0C14.0428 0 12.1679 0.352063 10.4346 0.995188V31.0048C12.1679 31.648 14.0428 32 15.9999 32C24.8364 32 31.9999 24.8365 31.9999 16Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 21.5652C13.5084 21.5652 16 19.0735 16 16C16 12.9264 13.5084 10.4348 10.4348 10.4348C7.36125 10.4348 4.86963 12.9264 4.86963 16C4.86963 19.0735 7.36125 21.5652 10.4348 21.5652Z",
    fill: "#FFDA44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30518 13.2173V16.6956C7.30518 18.4245 8.70667 19.826 10.4356 19.826C12.1645 19.826 13.566 18.4245 13.566 16.6956V13.2173H7.30518Z",
    fill: "#D80027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4341 17.739C9.85875 17.739 9.39062 17.2709 9.39062 16.6955V15.3043H11.4776V16.6956C11.4776 17.2709 11.0094 17.739 10.4341 17.739Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortugal);
export default __webpack_public_path__ + "static/media/portugal.6e27ffd1.svg";
export { ForwardRef as ReactComponent };